@if (hasFilters) {
  <button
    class="clear-all-filters-btn"
    (click)="clearFilters()"
  >
    {{ "CASES_TABLE.FILTERS.CLEAR_ALL" | translate }}
  </button>
}
